import styled from 'styled-components'
import { Swiper } from 'swiper/react'
import { sizeMobile, gutter } from 'components/globalStyles'

export const ListWrapper = styled.ul`
  @media (pointer: fine) and (hover: hover) {
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`

export const Title = styled.li`
  color: ${props => (props.selected ? 'var(--spBlack)' : 'var(--gray1)')};
  padding-top: 24px;
  position: relative;
  width: fit-content;
  cursor: ${props => (props.selected ? 'default' : 'pointer')};

  & h3,
  & h2 {
    color: ${props => (props.selected ? 'var(--spBlack)' : 'var(--gray1)')} !important;
    font-weight: ${props => (props.selected ? '600' : 'normal')};
    white-space: nowrap;
  }

  &::first-letter {
    text-transform: uppercase;
  }

  @media (max-width: ${sizeMobile}) {
    padding-top: 0;
  }
`

export const Body = styled.div`
  padding-top: 12px;
`

export const Underline = styled.img`
  position: absolute;
  bottom: -5px;
  width: 100%;
  height: 7px;
  visibility: ${props => (props.$visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.$visible ? 1.0 : 0.5)};

  ${Title}:hover & {
    visibility: visible;
  }
`

export const MobileTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const MobileSwiper = styled(Swiper)`
  width: calc(100vw - 2 * ${gutter});
`

export const LeftArrow = styled.img`
  position: absolute;
  left: 0;
  top: ${props => (props.small ? '5px' : '9px')};
  opacity: ${props => (props.disabled ? 0.25 : 1)};
  transition: 0.35s opacity;
  z-index: 2;
`

export const RightArrow = styled(LeftArrow)`
  left: auto;
  right: 0;
`
